<template>
  <div>
    <div v-if="preview.tooLarge" class="alert alert-warning mb-0">
      <strong>Conteúdo muito grande para exibir ({{ preview.size }}).</strong>
      Baixe o arquivo para visualizar.
      <button class="btn btn-outline ml-3" @click="download">Baixar</button>
    </div>

    <div v-else class="event-detail">
      <VueJsonPretty
        :data="data"
        :deep="deep"
        :showLength="true"
        :showLine="true"
      />
    </div>
  </div>
</template>

<script>
import DownloadCreator from '@/models/DownloadCreator'
import jsonPreview from '@/models/jsonPreview'
import VueJsonPretty from 'vue-json-pretty'

import 'vue-json-pretty/lib/styles.css'

export default {
  components: { VueJsonPretty },
  computed: {
    preview() {
      return jsonPreview(this.data)
    }
  },
  methods: {
    download() {
      DownloadCreator.download(this.filename, this.preview.json)
    }
  },
  name: 'EventDetailJson',
  props: {
    data: { default: null },
    deep: { default: 2, type: Number },
    filename: { required: true, type: String }
  }
}
</script>

<style scoped>
  .event-detail * {
    background: #051724;
    color: #FFF;
    padding: 16px;
    border-radius: 8px;
  }
</style>
